module.exports = __webpack_public_path__ + "static/img/glove_betterave.262be12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_betterave.png
// module id = cNJT
// module chunks = 0